<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import version from './version'
import ENV from './env'

export default {
  name: 'app',
  mounted () {
    this.setUnitIds()
    this.printVersion()
    this.logEnv()
  },
  methods: {
    printVersion () {
      console.log({ version })
    },
    logEnv () {
      console.log({ ENV })
    }
  },
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
::-webkit-scrollbar {
  display: none;
}
::-moz-scrollbar {
  display: none;
}
::-ms-scrollbar {
  display: none;
}
.tip-container {
  margin: 16px 0;

  .iconContainer-220 {
    font-size: 16px;
    min-width: 16px;
    min-height: 16px;
    display: flex;
    flex-shrink: 0;
    margin-top: 8px;
    margin-right: 0px;
    margin-bottom: 8px;
    margin-left: 12px;
  }
  .content-219 {
    display: flex;
    width: 100%;
    line-height: normal;
  }
  .text-222 {
    min-width: 0px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    margin-top: 8px;
    margin-right: 8px;
    margin-bottom: 8px;
    margin-left: 8px;
    font-family: 'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI',
      -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    font-size: 12px;
    font-weight: 400;
  }
  .icon-486 {
    display: inline-block;
    -webkit-font-smoothing: antialiased;
    font-style: normal;
    font-weight: normal;
    font-family: FabricMDL2Icons;
    color: rgb(121, 119, 117);
  }

  .text-463 {
    min-width: 0px;
    display: flex;
    flex-grow: 1;
    margin-top: 8px;
    margin-right: 12px;
    margin-bottom: 8px;
    margin-left: 8px;
    font-family: 'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI',
      -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    font-size: 12px;
    font-weight: 400;
  }
  .icon-483 {
    display: inline-block;
    -webkit-font-smoothing: antialiased;
    font-style: normal;
    font-weight: normal;
    font-family: FabricMDL2Icons-2;
    color: rgb(16, 124, 16);
  }
  .def-detail {
    padding-left: 0;
  }
}
.root-218 {
  font-family: 'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI',
    -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 14px;
  font-weight: 400;
  color: rgb(50, 49, 48);
  min-height: 32px;
  width: 100%;
  display: flex;
  word-break: break-word;
  flex-direction: column;
  background: rgb(243, 242, 241);
}

.root-479 {
  font-family: 'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI',
    -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 14px;
  font-weight: 400;
  color: rgb(50, 49, 48);
  min-height: 32px;
  width: 100%;
  display: flex;
  word-break: break-word;
  background: rgb(223, 246, 221);
}

.root-487 {
  font-family: 'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI',
    -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 14px;
  font-weight: 400;
  color: rgb(50, 49, 48);
  min-height: 32px;
  width: 100%;
  display: flex;
  word-break: break-word;
  flex-direction: column;
  // background: rgb(255, 244, 206);
  background: rgba(32, 160, 255, 0.1);
}
</style>














// WEBPACK FOOTER //
// src/App.vue